import { Close as CloseIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import MuiDialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import { Theme } from '@mui/system';
import { IconButton } from '@/wrappers/IconButton';

type IDialogTitleProps = Omit<DialogTitleProps, 'onClick'> & {
    subTitle?: React.ReactNode;
    onClose?: () => void;
};

const headerStyles = ({ theme, onClose }: { theme: Theme; onClose?: () => void }) => `
        padding: ${theme.spacing(2)};
        padding-right: ${onClose ? theme.spacing(6) : theme.spacing(4)};
        padding-left: ${theme.spacing(3)};
    `;
const TitleWithSubTitle: React.FC<DialogTitleProps> = (props) => <MuiDialogTitle {...props} component={Box} />;
const SimpleTitle = styled(MuiDialogTitle, {
    shouldForwardProp: (props) => props !== 'onClose'
})<{ onClose?: () => void }>(headerStyles);
const TitleWithSubtitle = styled(TitleWithSubTitle, {
    shouldForwardProp: (props) => props !== 'onClose'
})<{ onClose?: () => void }>(headerStyles);
const StyledButton = styled(IconButton)(
    ({ theme }) => `
        position: absolute;
        top: ${theme.spacing(1)};
        right: ${theme.spacing(1.5)};
        color: ${theme.palette.grey[500]};
    `
);

export const DialogTitle = ({ children, subTitle, onClose, ...props }: React.PropsWithChildren<IDialogTitleProps>) =>
    children ? (
        subTitle ? (
            <TitleWithSubtitle {...props}>
                {children}
                {subTitle}
                {!!onClose && (
                    <StyledButton name="close" aria-label="close" onClick={onClose}>
                        <CloseIcon />
                    </StyledButton>
                )}
            </TitleWithSubtitle>
        ) : (
            <SimpleTitle {...props}>
                {children}
                {subTitle && <>{subTitle}</>}
                {!!onClose && (
                    <StyledButton name="close" aria-label="close" onClick={onClose}>
                        <CloseIcon />
                    </StyledButton>
                )}
            </SimpleTitle>
        )
    ) : null;
